import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Double-leaf site gate; the latch is a filled bar, the rest strokes.
export const GATE_NODES: IconNode = [
  [
    'path',
    {
      key: 'gate-0',
      d: 'M5 19V9.6C5 8.38 5.48464 7.20998 6.34731 6.34731C7.20998 5.48464 8.38 5 9.6 5H14.4C15.0041 5 15.6022 5.11898 16.1603 5.35015C16.7184 5.58133 17.2255 5.92016 17.6527 6.34731C18.0798 6.77446 18.4187 7.28156 18.6498 7.83966C18.881 8.39775 19 8.99592 19 9.6V19H5Z',
    },
  ],
  [
    'path',
    {
      key: 'gate-1',
      d: 'M3 7V17',
    },
  ],
  [
    'path',
    {
      key: 'gate-2',
      d: 'M21 7V17',
    },
  ],
  [
    'path',
    {
      key: 'gate-3',
      d: 'M12 5V19',
    },
  ],
  [
    'path',
    {
      key: 'gate-4',
      d: 'M9.69995 12.8999H14.3V15.1999H9.69995V12.8999Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]

export const GateIcon: LucideIcon = createLucideIcon('gate', GATE_NODES)
